var map = {
	"./en/card_2_1.png": "+/k2",
	"./es/card_2_1.png": "GOdL",
	"./pt/card_2_1.png": "llV0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gkJA";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/card_2_1\.png$
// module id = gkJA
// module chunks = 0